import "./App.css";

import Routing from "./pages/Routing";
import FloatingButtons from "./components/FloatingButtons/index.js";

function App() {
  return (
    <>
      <Routing />
      <FloatingButtons/>
    </>
  );
}

export default App;
